import { render } from "./logo.vue?vue&type=template&id=7fcbe65b"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__